import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { AnnouncementBar } from './components/AnnouncementBar';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { TransformationSection } from './components/TransformationSection';
import { PainPointsSection } from './components/PainPointsSection';
import { KitContentsSection } from './components/KitContentsSection';
import { InstantAccessSection } from './components/InstantAccessSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
import { StickyCTABar } from './components/StickyCTABar';
interface AppProps {
  showAnnouncementBar?: boolean;
  showStickyCTA?: boolean;
}
export function App({
  showAnnouncementBar = true,
  showStickyCTA = true
}: AppProps) {
  return <div className="min-h-screen w-full bg-brand-main font-sans text-brand-text selection:bg-brand-orange/25" data-id="element-0" data-mp="3mj6hxs835sdv">
      <MetaPixel data-id="element-1" data-mp="5yhupa6n3cr" />
      {showAnnouncementBar && <AnnouncementBar data-id="element-2" data-mp="4n4bxqxqh8g" />}
      <main data-id="element-3" data-mp="56lhc8rh1lf">
        <HeroSection data-id="element-4" data-mp="7suzhf7pr6a" />
        <StatsBar data-id="element-5" data-mp="2zld259q0hfbj" />
        <TransformationSection data-id="element-6" data-mp="2zlv8iz6e19x6" />
        <PainPointsSection data-id="element-7" data-mp="2zmwi0z7r9ocs" />
        <KitContentsSection data-id="element-8" data-mp="33mou3lwcycmw" />
        <InstantAccessSection data-id="element-9" data-mp="33lwyib2rgewm" />
        <BonusesSection data-id="element-10" data-mp="33n6xr3lcnt4u" />
        <PricingSection data-id="element-11" data-mp="33oi2b5mmd4x0" />
        <GuaranteeSection data-id="element-12" data-mp="38m1iwc6shts4" />
        <TestimonialsSection data-id="element-13" data-mp="38kqfwel64q22" />
        <FAQSection data-id="element-14" data-mp="38nuorp9kw9z2" />
        <FinalCTASection data-id="element-15" data-mp="3dkuu1xylt8p4" />
      </main>
      <Footer data-id="element-16" data-mp="3dlw5w4ng1z7w" />
      {showStickyCTA && <StickyCTABar data-id="element-17" data-mp="3dm5vhr4ku4d2" />}
    </div>;
}